/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_FeaturesInputs */

const cs_form_features = /** @type {(inputs: Form_FeaturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vybavení`)
};

const en_form_features = /** @type {(inputs: Form_FeaturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Features`)
};

/**
* | output |
* | --- |
* | "Features" |
*
* @param {Form_FeaturesInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_features = /** @type {((inputs?: Form_FeaturesInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_FeaturesInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_features(inputs)
	return cs_form_features(inputs)
});